module.exports = __webpack_public_path__ + "img/horse.2fdf6102.svg";